import React, { useState } from "react";
import BasicGrid from "./Grid";
import { FilterMode } from "./Filter";
import { getScanApi, getScanSaveApi } from "../../../services/nearToExpiry";
import { useNearToExpiryStore } from "../../../store/useNearToExpiryStore";
import dayjs from "dayjs";
import { Button, List, message, Modal, Table } from "antd";
import { useNearToExpiryScanStore } from "../../../store/useNTEScanStore";

const NearToExpiryScan = () => {
  // const [gridData, setGridData] = useState([]);
  // const [resetKey, setResetKey] = useState(0);
  // const [modalVisible, setModalVisible] = useState(false);
  // const [isModalOpen, setIsModalOpen] = useState(false);

  // const [multiOptions, setMultiOptions] = useState([]);
  const {
    modalVisible,
    multiOptions,
    addOrUpdateRow,
    qtyErrorModal,
    setQtyErrorModal,
  } = useNearToExpiryScanStore();
  // const handleBarcodeScan = async (data) => {
  //   const { StoreCode, date, searchBy, searchBarCode } = data;
  //   if (!searchBarCode) return;

  //   const payload = {
  //     location: StoreCode,
  //     date: dayjs(date).format("YYYY-MM-DD"),
  //     searchBy,
  //     searchValue: searchBarCode,
  //   };

  //   try {
  //     const response = await getScanApi(payload); // call API
  //     const data = response?.Data || [];

  //     if (data.length === 0 || data[0]?.Status === "0") {
  //       message.warning("No data found for this barcode");
  //       return;
  //     }

  //     if (data.length === 1) {
  //       addOrUpdateRow(data[0]);
  //     } else {
  //       // multiple items returned, ask user to select
  //       setMultiOptions(data);
  //       setModalVisible(true);
  //     }
  //   } catch (err) {
  //     console.error("Scan API error:", err);
  //     message.error("Failed to fetch scanned data");
  //   }
  // };

  // const handleSave = async (StoreCode) => {
  //   try {
  //     const payload = gridData.map((row) => ({
  //       locationCode: StoreCode,
  //       populatedDate: new Date().toISOString(),
  //       manufacturingDate: row.ManufacturingDate,
  //       articleCode: row.ArticleCode,
  //       expiryType: row.ExpiryType,
  //       scanQty: row.ScanQty || row.scanqty,
  //       scanMrp: row.MRP,
  //     }));

  //     if (!payload.length) {
  //       message.warning("No scanned data to save");
  //       return;
  //     }

  //     await getScanSaveApi(payload);

  //     message.success("Scan data saved successfully");

  //     // reset scanqty after saving
  //     setGridData([]);
  //     setResetKey((prev) => prev + 1);
  //   } catch (err) {
  //     console.error(err);
  //     message.error("Failed to save scan data");
  //   }
  // };
  // const handleSelectOption = (item) => {
  //   addOrUpdateRow(item);
  // };

  // const addOrUpdateRow = (item) => {
  //   setGridData((prev) => {
  //     const index = prev.findIndex((r) => r.NearExpiryID === item.NearExpiryID);

  //     const expiryQty = item.ExpiryQty ?? 0;

  //     if (index >= 0) {
  //       const currentQty = prev[index].ScanQty || 0;
  //       const newQty = currentQty + 1;

  //       if (newQty > expiryQty) {
  //         setIsModalOpen(true);
  //         return prev;
  //       }

  //       const updated = [...prev];
  //       updated[index] = {
  //         ...updated[index],
  //         ScanQty: newQty,
  //         scanqty: newQty,
  //       };
  //       return updated;
  //     }

  //     if (1 > expiryQty) {
  //       setIsModalOpen(true);
  //       return prev;
  //     }

  //     return [
  //       ...prev,
  //       {
  //         ...item,
  //         serialNo: prev.length + 1,
  //         ScanQty: 1,
  //         scanqty: 1,
  //       },
  //     ];
  //   });

  //   setModalVisible(false);
  //   setMultiOptions([]);
  // };

  return (
    <>
      <FilterMode
      // key={resetKey}
      // onBarcodeScan={handleBarcodeScan}
      // onSave={handleSave}
      />
      <BasicGrid
      //  gridData={gridData} setGridData={setGridData}
      />
      {/* Modal for multiple scan options */}
      <Modal
        title="Select an Item"
        open={modalVisible}
        onCancel={() =>
          useNearToExpiryScanStore.setState({
            modalVisible: false,
            multiOptions: [],
          })
        }
        footer={null}
        width={750}
      >
        <Table
          dataSource={multiOptions}
          rowKey="NearExpiryID"
          pagination={false}
          columns={[
            {
              title: "Item Description",
              dataIndex: "ShortDesc",
              key: "ShortDesc",
            },
            {
              title: "Manufacturing Date",
              dataIndex: "ManufacturingDate",
              key: "ManufacturingDate",
              render: (date) => dayjs(date).format("DD/MM/YY"),
            },

            {
              title: "MRP",
              dataIndex: "MRP",
              key: "MRP",
            },
            {
              title: "Action",
              key: "action",
              render: (_, record) => (
                <Button type="primary" onClick={() => addOrUpdateRow(record)}>
                  Select
                </Button>
              ),
            },
          ]}
        />
      </Modal>
      <Modal
        open={qtyErrorModal}
        footer={[
          <div
            key="ok-btn"
            style={{
              width: "100%",
              textAlign: "center",
              paddingBottom: "10px",
            }}
          >
            <button
              onClick={() => setQtyErrorModal(false)}
              style={{
                padding: "8px 28px",
                backgroundColor: "#1677ff",
                color: "#fff",
                border: "none",
                borderRadius: "6px",
                fontSize: "14px",
                cursor: "pointer",
              }}
            >
              OK
            </button>
          </div>,
        ]}
        closable={false} // ❌ remove top-right X
        centered
      >
        <p
          style={{
            fontSize: "25px", // text bada
            color: "#333",
            textAlign: "center",
            marginBottom: "20px",
          }}
        >
          Scan Qty cannot be greater than Expiry Qty
        </p>
      </Modal>
    </>
  );
};

export default NearToExpiryScan;
